module.exports = __webpack_public_path__ + "static/media/BrixSans-Bold.e27c3d57.ttf";